import React from 'react';
import { Section } from './Section';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Compré un domingo a la noche. El lunes entré a la cancha con el plan exacto del entrenamiento. El Tomo 1 es exactamente lo que necesitaba para organizar toda mi temporada. Nunca más improviso.',
  name: 'Martín G.',
  role: 'Profe de Volley en Club Deportivo',
  loc: '📍 Buenos Aires'
}, {
  quote: 'El Tomo 2, el de los 80 ejercicios, me cambió todo. El primer mes, jugadoras que llevaban meses estancadas mejoraron visiblemente su técnica. El fichero de ejercicios me da la tranquilidad que antes no tenía.',
  name: 'Carolina R.',
  role: 'Profe en Centro Deportivo',
  loc: '📍 Rosario'
}, {
  quote: 'El sistema de progresión es único en el mercado. 80 ejercicios listos para usar con diagramas de cancha, objetivos y variantes por nivel. Antes tardaba horas armando una secuencia. Ahora abro el PDF y en 5 minutos tengo todo listo.',
  name: 'Valeria F.',
  role: 'Profe de Volley Grupal e Individual',
  loc: '📍 Córdoba'
}, {
  quote: 'Las planillas del Tomo 3 eliminaron mi inseguridad al evaluar. Ahora sé exactamente en qué está cada jugadora y puedo mostrárselo a los padres y al club. Mis entrenamientos tienen otro nivel de profesionalismo.',
  name: 'Luciana P.',
  role: 'Profe Particular y en Gimnasio',
  loc: '📍 Tucumán'
}, {
  quote: 'La tasa de abandono de mis grupos bajó muchísimo. Sin cambiar lo que enseño. Solo aplicando el sistema de progresión y la variedad de los 6 tomos. Las jugadoras ahora quieren venir porque siempre hay algo nuevo.',
  name: 'Marcela G.',
  role: 'Profe de Volley Online y Presencial',
  loc: '📍 Mendoza'
}, {
  quote: 'El Tomo 6 de marketing me salvó de seguir dependiendo del boca a boca. Ahora tengo un sistema para atraer jugadoras. Mis grupos están llenos por primera vez en dos años.',
  name: 'Laura V.',
  role: 'Profe de Volley en Club Propio',
  loc: '📍 Santa Fe'
}, {
  quote: 'El Pack Élite me cambió la cabeza. Nunca había dimensionado el potencial de profesionalizar mi imagen y tener mi propia academia. Ahora trabajo con una seguridad que antes no tenía y cobro lo que realmente merezco.',
  name: 'Ana R.',
  role: 'Profe en Centro Deportivo',
  loc: '📍 Salta'
}];
export function ExtendedTestimonials() {
  return <Section data-id="element-127">
      <div className="text-center mb-6 md:mb-16" data-id="element-128">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-2 md:mb-4" data-id="element-129">
          Lo que dicen los profes que ya lo usan:
        </h2>
        <p className="text-base md:text-xl text-gold-400" data-id="element-130">
          +300 profes de volley de todo el país ya tienen su Profe de Volley
          Resuelto™
        </p>
      </div>

      <div className="columns-1 md:columns-2 lg:columns-3 gap-3 md:gap-6 space-y-3 md:space-y-6 max-w-7xl mx-auto" data-id="element-131">
        {testimonials.map((t, i) => <div key={i} className="break-inside-avoid bg-navy-800 p-4 md:p-6 rounded-xl md:rounded-2xl border border-navy-700 hover:border-gold-500/30 transition-colors" data-id="element-132">
            <div className="flex gap-1 mb-2 md:mb-4" data-id="element-133">
              {[...Array(5)].map((_, j) => <Star key={j} className="w-3 h-3 md:w-4 md:h-4 fill-gold-500 text-gold-500" data-id="element-134" />)}
            </div>
            <p className="text-gray-300 text-xs md:text-base leading-relaxed mb-3 md:mb-6" data-id="element-135">
              "{t.quote}"
            </p>
            <div data-id="element-136">
              <p className="font-heading font-bold text-white text-sm md:text-base" data-id="element-137">
                {t.name}
              </p>
              <p className="text-[10px] md:text-xs text-gold-400 mt-0.5 md:mt-1" data-id="element-138">
                {t.role}
              </p>
              <p className="text-[10px] md:text-xs text-gray-500 mt-0.5 md:mt-1" data-id="element-139">
                {t.loc}
              </p>
            </div>
          </div>)}
      </div>
    </Section>;
}